'use client'

import { useMedia } from 'react-use'

const breakpoints = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
}

export function useTailwindMediaQuery() {
  const isSm = useMedia(`(min-width: ${breakpoints.sm})`, false)
  const isMd = useMedia(`(min-width: ${breakpoints.md})`, false)
  const isLg = useMedia(`(min-width: ${breakpoints.lg})`, false)
  const isXl = useMedia(`(min-width: ${breakpoints.xl})`, false)

  return { isSm, isMd, isLg, isXl }
}
